import { render, staticRenderFns } from "./OrgManagementForm.vue?vue&type=template&id=5fece5b0&"
import script from "./OrgManagementForm.vue?vue&type=script&lang=js&"
export * from "./OrgManagementForm.vue?vue&type=script&lang=js&"
import style0 from "./OrgManagementForm.vue?vue&type=style&index=0&id=5fece5b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports